<template lang="pug">
  .lesson-block.main-block
    Preview(
      v-if="!testHasAnswers && !testStarted"
      :content="contentLocal"
      @startTest="startTest"
    )

    Questions(
      v-else-if="(testHasAnswers || testStarted) && !testFinished"
      :propContent="contentLocal"
      @setPoints="setPoints"
      @finishTest="finishTest"
    )

    Result(
      v-else-if="testFinished"
      :content="contentLocal"
    )
    slot
</template>

<script>
import _ from 'lodash';
import Preview from './Preview';
import Questions from './Questions';
import Result from './Result';

export default {
  components: { Preview, Questions, Result },
  props: ['content'],
  data() {
    return {
      testStarted: false,
      testFinished: false,
      contentLocal: {
        questions: [],
        points: ''
      }
    };
  },
  computed: {
    testHasAnswers() {
      let hasAnswer;
      this.contentLocal.questions.forEach(q => {
        if (hasAnswer) {
          return;
        }
        if (q.userAnswerIds.length > 0) {
          hasAnswer = true;
        }
      });
      return hasAnswer;
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
      if (typeof this.contentLocal.points === 'number') {
        this.testFinished = true;
      }
    },
    startTest() {
      this.testStarted = true;
    },
    setPoints(res) {
      if (res) {
        this.contentLocal.points = res.points;
        this.$store.dispatch('lms/setMenuData', {
          path: 'numbers',
          value: res.numbers
        });
      }
    },
    finishTest() {
      this.testFinished = true;
    }
  }
};
</script>

<style>
@import '~swiper/swiper-bundle.css';
</style>
